import React, { useState } from 'react';
import { Search } from 'lucide-react';
import Input from './ui/Input';
import Button from './ui/Button';

export default function ReportFilters({ onFilterChange }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        // Debounce logic could be added here, for now direct pass
        onFilterChange({ search: term, dateFrom, dateTo });
    };

    const handleDateChange = (field, value) => {
        if (field === 'from') setDateFrom(value);
        else setDateTo(value);

        onFilterChange({
            search: searchTerm,
            dateFrom: field === 'from' ? value : dateFrom,
            dateTo: field === 'to' ? value : dateTo
        });
    };

    return (
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col md:flex-row gap-4 items-end md:items-center justify-between mb-6">
            <div className="w-full md:w-1/3">
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                    <input
                        type="text"
                        placeholder="Поиск по названию или автору..."
                        className="pl-10 w-full h-10 rounded-lg border border-gray-300 text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>
            </div>

            <div className="flex gap-4 w-full md:w-auto items-center">
                <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-500 whitespace-nowrap">Дата:</span>
                    <input
                        type="date"
                        className="h-10 rounded-lg border border-gray-300 text-sm px-3 focus:ring-2 focus:ring-primary-500 outline-none"
                        value={dateFrom}
                        onChange={(e) => handleDateChange('from', e.target.value)}
                    />
                    <span className="text-gray-400">-</span>
                    <input
                        type="date"
                        className="h-10 rounded-lg border border-gray-300 text-sm px-3 focus:ring-2 focus:ring-primary-500 outline-none"
                        value={dateTo}
                        onChange={(e) => handleDateChange('to', e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
}
